// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1QAbw","title":"InfoRow_title__pV5H9"};